import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import MicroQualificationService from "../../services/MicroQualificationService";

let initialState = {
    fields: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllEducationFields = createAsyncThunk(
    'getAllEducationFields',
    async ({page, limit}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await MicroQualificationService.getEducationFields(page, limit);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const educationFieldsSlice = createSlice({
    name: 'educationFieldsSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllEducationFields.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllEducationFields.fulfilled, (state, action) => {
                state.isLoading = false;
                state.fields = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllEducationFields.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.fields = [];
                state.hasMore = false;
            })
    }
});

export const {} = educationFieldsSlice.actions;

export default educationFieldsSlice.reducer;